import { render, staticRenderFns } from "./AgreeRegister.vue?vue&type=template&id=140b88dd&"
import script from "./AgreeRegister.vue?vue&type=script&lang=js&"
export * from "./AgreeRegister.vue?vue&type=script&lang=js&"
import style0 from "./AgreeRegister.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports